module.exports = __webpack_public_path__ + "img/12.c1cf186f.jpg";